import React, { useEffect } from "react";
import RoboBoomTemplate from "../../../Templetes/Categories/Details/RoboBoom/RoboBoom.template";

const RoboBoomPage = () => {
  useEffect(() => {
    document.title = "Internatioal Robot Challenge - RoboBoom";
  }, []);
  return <RoboBoomTemplate />;
};

export default RoboBoomPage;
